// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-indicator {
    width: 100%;
    display: block;
}`, "",{"version":3,"sources":["webpack://./app/Components/Commons/loading-indicator/loading-indicator.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB","sourcesContent":[".loading-indicator {\r\n    width: 100%;\r\n    display: block;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
